import { RootState } from '../store';

export const getSessionCredentials = (state:RootState) => state.tankBotSession;